<div class="container">
  <div class="dashboard-header row">
    <div class="col-lg-6">
      <header class="page-header-title" i18n>User overview</header>
      @if (totalCount !== null) {
        <p class="page-sub-header" i18n>{totalCount, plural, 0 {No active users} 1 {{{totalCount}} active user} other {{{totalCount}} active users}}</p>
      }
    </div>
    @if (userRole && userRole !== RoleEnum.USER) {
      <div class="col-lg-6 new-user-button">
        <button (click)="createUser()"><i class="fal fa-user-plus new-user-button-icon"></i><ng-container i18n>Add new user</ng-container></button>
      </div>
    }
  </div>

  <div class="content-card-background">
    <div class="header-row">
      <div class="button-group-border">
        <div class="button-group clearfix">
          <div
            class="group-button"
            [class.selected]="selection$.value === null"
            (click)="selection$.next(null)">
            <a i18n>All</a>
          </div>
          <div
            class="group-button"
            [class.selected]="selection$.value === RoleEnum.USER"
            (click)="selection$.next(RoleEnum.USER)">
            <a i18n>User</a>
          </div>
          <div
            class="group-button"
            [class.selected]="selection$.value === RoleEnum.ADMIN"
            (click)="selection$.next(RoleEnum.ADMIN)">
            <a i18n>Admin</a>
          </div>
        </div>
      </div>

      <select [formControl]="first">
        <option [ngValue]="20">20</option>
        <option [ngValue]="40">40</option>
        <option [ngValue]="60">60</option>
      </select>
    </div>

    @if (users.length < 1 && loading === false) {
      <h4 class="no-users" i18n>No users found</h4>
    }

    @for (user of users; track user.id; let isLast = $last) {
      <li class="user-row" [class.no-bottom-line]="isLast && pageCount <= 1">
        <div class="table-body-left clearfix">
          @if (user.photo !== null) {
            <img src="{{ user.photo }}" class="user-image" alt="" (click)="navigateToProfile(user.id)">
          } @else {
            <div class="no-user-photo" (click)="navigateToProfile(user.id)"><i class="fal fa-user"></i></div>
          }
          <div class="user-details">
            <div class="clearfix user-top-row">
              <h1 class="username" (click)="navigateToProfile(user.id)">{{ user.firstName }} {{ user.lastName }}</h1>
            </div>
            <div class="user-middle-row">
              @switch (user.role) {
                @case (RoleEnum.SUPERADMIN) {
                  <p class="user-role" i18n>Super admin</p>
                }
                @case (RoleEnum.ADMIN) {
                  <p class="user-role" i18n>Admin</p>
                }
                @case (RoleEnum.USER) {
                  <p class="user-role" i18n>User</p>
                }
              }
            </div>
            <div class="user-bottom-row">
              <p class="user-email">{{ user.email }}</p>
            </div>
          </div>
        </div>
        @if (userRole === RoleEnum.ADMIN || userRole === RoleEnum.SUPERADMIN) {
          <div class="table-body-right clearfix">
            <div class="content-options-button" (click)="selectDropdown(user.id)">
              @if (activeDropdown === user.id) {
                <i class="fa-regular fa-xmark"></i>
              } @else {
                <i class="fas fa-ellipsis-v"></i>
              }
            </div>
            @if (activeDropdown === user.id) {
              <div class="content-options-dropdown">
                <button class="dropdown-button report-button" (click)="navigateToProfileEdit(user.id)"><i class="fas fa-pencil"></i><ng-container i18n>Edit user</ng-container></button>
                <button class="dropdown-button delete-button" (click)="deleteUser(user.id)"><i class="far fa-times-circle"></i><ng-container i18n>Delete user</ng-container></button>
              </div>
            }
          </div>
        }
      </li>
    }

    @if (pageCount > 1) {
      <div class="footer-pager-row">
        <button (click)="previousPage()" [disabled]="offset.value <= 1" class="skideo-flat-button black img-left">
          <i class="fas fa-arrow-left next-page-button-icon"></i>
          <ng-container i18n>Previous page</ng-container>
        </button>
        <select [formControl]="offset">
          @for (number of pages; track number) {
            <option [ngValue]="number + 1">{{ number + 1 }}</option>
          }
        </select>
        <button (click)="nextPage()" [disabled]="offset.value >= pageCount" class="skideo-flat-button black img-right">
          <ng-container i18n>Next page</ng-container>
          <i class="fas fa-arrow-right next-page-button-icon"></i>
        </button>
      </div>
    }

  </div>
</div>
